(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/serversiderendering.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/serversiderendering.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.app.ServerSideHelper.ServerSideRendering = Marionette.Behavior.extend({
    onServersideInitialized: function onServersideInitialized() {
      if (this.view.getOption('preRendered')) {
        this.view.triggerMethod('attach');

        if (this.view instanceof Marionette.View && typeof this.getOption('regionSetup') === 'function') {
          var settingsArray = Object.keys(this.getOption('regionSetup').call(this.view));

          for (var i = 0, iLen = settingsArray.length; i < iLen; i++) {
            var region = this.view.getRegion(settingsArray[i]);

            if (region && region.currentView) {
              var currentView = region.currentView;
              region.triggerMethod('show');

              if (currentView._firstTimeServerSideRender === undefined) {
                region.currentView.triggerMethod('attach');
              } else {
                region.currentView.triggerMethod('serverside:initialized');
              }
            }
          }
        } else if (this.view instanceof Marionette.CollectionView) {
          this.view.children.each(function (view) {
            if (view._firstTimeServerSideRender === undefined) {
              view.triggerMethod('attach');
            } else {
              view.triggerMethod('serverside:initialized');
            }
          });
        }
      }
    },
    onAttachServerside: function onAttachServerside() {
      var settings, settingsArray, setting, emptyView;

      if (this.view.getOption('preRendered')) {
        if (this.view instanceof Marionette.View && typeof this.getOption('regionSetup') === 'function') {
          settings = this.getOption('regionSetup').call(this.view);
          settingsArray = Object.keys(settings);

          for (var i = 0, iLen = settingsArray.length; i < iLen; i++) {
            setting = settings[settingsArray[i]];
            var region = this.view.getRegion(settingsArray[i]);

            if (!region) {
              svs.app.ServerSideHelper.logger.error("Region ".concat(settingsArray[i], " was not defined in the view."));
            } else if (!setting.view) {
              svs.app.ServerSideHelper.logger.error("View to initialize in region ".concat(settingsArray[i], " was not defined. Check regionSetup for typos."));
            } else if (region.$el.length) {
              var viewInstnace = new setting.view(_.extend({}, setting.options, {
                preRendered: true,
                el: region.$el.children().length > 1 ? region.$el : region.$el.children().first()
              }));
              region.currentView = viewInstnace;
              svs.app.ServerSideHelper.utils.initView(viewInstnace, region);

              this.view._proxyChildViewEvents(viewInstnace);
            } else {
              svs.app.ServerSideHelper.logger.error("Region ".concat(settingsArray[i], " was not found in the DOM."));
            }
          }
        } else if (this.view instanceof Marionette.CollectionView) {
          if (this.view.collection.isEmpty() && this.view.emptyView) {
            emptyView = new this.view.emptyView(_.extend({
              el: this.$el.children(':nth-child(1)'),
              preRendered: true,
              model: new Backbone.Model()
            }, this.view.childViewOptions && this.view.childViewOptions() || undefined)); 

            this.view._proxyChildViewEvents(emptyView); 


            this.view.children.add(emptyView);
          } else {
            if (this.view.$el.children().length !== this.view.collection.length) {
              this.view.$el.html('');
              this.view.render();
            } else if (this.view.$el.children().length === 1 && this.view.collection.length === 1 && this.$el.children()[0].dataset && this.$el.children()[0].dataset.ssremptyview) {
              this.view.$el.html('');
              this.view.render();
            } else {
              this.view.collection.each(function (model, index) {
                var view = new this.childView(_.extend({
                  el: this.$el.children().length ? this.$el.children(":nth-child(".concat(index + 1, ")")) : undefined,
                  preRendered: true,
                  model: model
                }, this.childViewOptions && this.childViewOptions() || undefined)); 

                this._proxyChildViewEvents(view);

                view._index = index; 

                if (model.hasChanged()) {
                  view.render();
                }

                this.children.add(view);
              }, this.view);
            }
          }

          this.view._isRendered = true;
          this.view._isAttached = true;
          this.view.off('render', this.view._initialEvents);

          this.view._initialEvents();
        }
      }
    },
    initialize: function initialize() {
      if (this.view.getOption('preRendered')) {
        this.view._firstTimeServerSideRender = true;
      }
    },
    onDomRefresh: function onDomRefresh() {
      if (this.view instanceof Marionette.View && (!this.view.getOption('preRendered') || this.view._isServersideAttached)) {
        if (!this.view._firstTimeServerSideRender && typeof this.getOption('regionSetup') === 'function') {
          var settings = this.getOption('regionSetup').call(this.view),
              settingsArray = Object.keys(settings);

          for (var i = 0, iLen = settingsArray.length; i < iLen; i++) {
            var setting = settings[settingsArray[i]];
            this.view.getRegion(settingsArray[i]).show(new setting.view(setting.options));
          }
        }

        this.view._firstTimeServerSideRender = false;
      }
    }
  }); 

  svs.app.behaviors.ServerSideRendering = svs.app.ServerSideHelper.ServerSideRendering;
})(Backbone, _, svs);
 })(window);